import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { I18nProvider } from './providers/I18nProvider.tsx'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </StrictMode>,
)
